<template>
  <div class="slider">
    <div class="slider__title">
      <div class="slider__label sf-sb">
        <slot name="label"/>
      </div>
      <div class="slider__value">
        <span class="slider__value__text">
          <slot name="value" :value="value"/>
        </span>
        <select v-if="max > 0" v-model="model" class="slider__select">
          <option v-for="val in range" :key="val" :value="val">
            {{ val | bigNumber }}
          </option>
        </select>
      </div>
    </div>

    <div v-show="editable" class="slider__element" @mousedown="$emit('mousedown')">
      <no-ssr>
        <div slot="placeholder" style="height: 40px"/>
        <sf-slider ref="slider" v-model="model" :settings="settings" :disabled="disabled"/>
      </no-ssr>
      <div class="slider__range">
        <div ref="min" :style="{ opacity: showMin ? 1 : 0 }">
          {{ min | bigNumber }}
        </div>
        <div ref="max" :style="{ opacity: showMax ? 1 : 0 }">
          {{ max | bigNumber }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import range from 'lodash/range';

export default {
  props: {
    settings: { type: Object, required: true },
    value: { type: Number, required: true },
    editable: { type: Boolean, default: true },
  },
  data: () => ({
    minSize: 0,
    maxSize: 0,
    progress: 0,
    dotSize: 0,
    size: 0,
  }),
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    min() {
      return this.settings.min;
    },
    max() {
      return this.settings.max;
    },
    step() {
      return this.settings.interval;
    },
    range() {
      return range(this.min, this.max + 1, this.step);
    },
    showMin() {
      return !!this.min && this.minSize + this.dotSize / 2 < this.progress;
    },
    showMax() {
      return this.progress + this.dotSize / 2 < this.size - this.maxSize;
    },
    disabled() {
      return this.max < 0 || this.min <= 0 || this.min === this.max;
    },
  },
  watch: {
    async editable() {
      await this.$nextTick();
      this.refresh();
    },
  },
  async mounted() {
    await this.$nextTick();

    this.progress = this.$refs.slider.position;
    this.$watch('$refs.slider.position', val => {
      this.progress = val;
    });

    this.size = this.$refs.slider.size;
    this.$watch('$refs.slider.size', val => {
      this.size = val;
    });

    try {
      this.dotSize = this.$refs.slider.sliderStyle.dotSize;
    } catch {
      this.dotSize = 36;
    }

    this.updateMin();
    this.$watch('min', this.updateMin);

    this.updateMax();
    this.$watch('max', this.updateMax);
  },
  methods: {
    refresh() {
      this.$refs.slider.refresh();
    },
    updateMin() {
      this.minSize = this.$refs.min.clientWidth;
    },
    updateMax() {
      this.maxSize = this.$refs.max.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.slider {
  margin-top: 30px;

  &:first-child {
    margin-top: 0;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__label {
  }

  &__value {
    position: relative;
    font-size: 20px;

    &__text {
      @include mobile {
        pointer-events: none;
      }
    }
  }

  &__select {
    @extend %overlay;
    position: absolute;
    z-index: 0;
    font-size: 24px;
    text-align: right;
    text-align-last: right;
    appearance: none;
    border: none;
    outline: none;
    background: none;
    color: inherit;
    opacity: 0;

    @include tablet {
      display: none;
    }
  }

  &__range {
    margin-top: -10px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;

    & > * {
      transition: opacity 0.3s;
    }
  }
}
</style>
